import React from "react";
import "./App.css";
import VideoPlayer from "./videoplayer";
import Grid from "@material-ui/core/Grid";

function App() {
  return (
    <Grid container>
      <Grid item xs={12}>
        <VideoPlayer />
      </Grid>
    </Grid>
  );
}

export default App;
